import { CreateButton } from 'react-admin';
import { Stack, Typography } from '@mui/material';
import useAppBarHeight from '../misc/useAppBarHeight';

export const CompanyEmpty = () => {
	const appbarHeight = useAppBarHeight();
	return (
		<Stack
			justifyContent="center"
			alignItems="center"
			gap={3}
			sx={{
				height: `calc(100dvh - ${appbarHeight}px)`
			}}
		>
			<img src="./img/empty.svg" alt="No companies found" />
			<Stack gap={0} alignItems="center">
				<Typography variant="h6" fontWeight="bold">
					No companies found
				</Typography>
				<Typography
					variant="body2"
					align="center"
					color="text.secondary"
					gutterBottom
				>
					It seems your company list is empty.
				</Typography>
			</Stack>
			<Stack spacing={2} direction="row">
				<CreateButton variant="contained" label="Create Company" />
			</Stack>
		</Stack>
	);
};
